import { configs } from '../../configs';
import { createAxios } from '../../utils/createAxios';

export const api = createAxios(configs.baseUrl.productService);
